import { useState, useEffect } from "react";
import { fetchJourneyGroups } from "../utils/api-requests/journey-index";


//TODO: DELETE THIS FILE
const useJourneyGroups = () => {
  const [selectedJourneyGroup, setSelectedJourneyGroup] = useState({});
  const [journeyGroups, setJourneyGroups] = useState([]);

  // Get a list of journey groups for user & org
  // Arbitrarily pick the first in the list (for now).
  useEffect(() => {
    const getAndSetJourneyGroups = async () => {
      const journeyGroups = await fetchJourneyGroups();
      setJourneyGroups(journeyGroups);
      setSelectedJourneyGroup(journeyGroups[0]); // arbitrarily pick first one for now.
    };

    getAndSetJourneyGroups();
  }, []);

  return {
    setSelectedJourneyGroup,
    journeyGroups,
    selectedJourneyGroup,
  };
};

export default useJourneyGroups;
